import React from 'react';
import { HeartPulse, Smile, Headset, Briefcase } from 'lucide-react';
import { CAPABILIA_GREEN } from './landingConstants';

const MODULES = [
  { icon: HeartPulse, title: 'Persistencia', desc: 'Semáforo de riesgo, acciones de retención y grupo de control.' },
  { icon: Smile, title: 'Satisfacción NPS', desc: 'Encuestas y seguimiento del pulso de satisfacción por cohorte.' },
  { icon: Headset, title: 'Calidad de Atención', desc: 'Scoring de conversaciones de soporte con IA, por agente.' },
  { icon: Briefcase, title: 'Vista Comercial', desc: 'Estado de cobranza y relación comercial integrado con HubSpot.' },
];

export const LandingModules = () => (
  <section id="modulos" className="bg-gray-50 py-20" data-testid="landing-modules">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <p className="text-sm font-semibold text-emerald-700 mb-3">Módulos 360</p>
        <h2 className="font-manrope text-3xl sm:text-4xl font-bold text-gray-900">
          Una vista completa del alumno, no cuatro sueltas
        </h2>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {MODULES.map((mod) => (
          <div key={mod.title} className="bg-white border border-gray-100 rounded-2xl p-6" data-testid={`landing-module-${mod.title.toLowerCase().replace(/\s/g, '-')}`}>
            <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-4" style={{ backgroundColor: `${CAPABILIA_GREEN}1A` }}>
              <mod.icon className="w-5 h-5" style={{ color: CAPABILIA_GREEN }} />
            </div>
            <h3 className="font-manrope font-bold text-gray-900 mb-2">{mod.title}</h3>
            <p className="text-sm text-gray-600 leading-relaxed">{mod.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
